import { TableBodyContent } from './TableBodyContent';

export default TableBodyContent;
